import { defineNuxtPlugin } from '#app/nuxt'
import { LazyFacebookVideoEmbed, LazyStreamVideoEmbed, LazyWmtVideoEmbed, LazyYoutubeVideoEmbed, LazyContentBlocks, LazyContentBlocksItem, LazyContentBlockImage, LazyContentBlockParagraph, LazyContentBlockPromoBanner, LazyContentBlockQuote, LazySectionWrapper, LazyUIButton, LazyUIDynamicHeading, LazyUIEmbedHtml, LazyUIIcon, LazyUIImage, LazyUILoadingCard, LazyUISelect, LazyUITableCell, LazyUITableHead, LazyUITable, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["FacebookVideoEmbed", LazyFacebookVideoEmbed],
["StreamVideoEmbed", LazyStreamVideoEmbed],
["WmtVideoEmbed", LazyWmtVideoEmbed],
["YoutubeVideoEmbed", LazyYoutubeVideoEmbed],
["ContentBlocks", LazyContentBlocks],
["ContentBlocksItem", LazyContentBlocksItem],
["ContentBlockImage", LazyContentBlockImage],
["ContentBlockParagraph", LazyContentBlockParagraph],
["ContentBlockPromoBanner", LazyContentBlockPromoBanner],
["ContentBlockQuote", LazyContentBlockQuote],
["SectionWrapper", LazySectionWrapper],
["UIButton", LazyUIButton],
["UIDynamicHeading", LazyUIDynamicHeading],
["UIEmbedHtml", LazyUIEmbedHtml],
["UIIcon", LazyUIIcon],
["UIImage", LazyUIImage],
["UILoadingCard", LazyUILoadingCard],
["UISelect", LazyUISelect],
["UITableCell", LazyUITableCell],
["UITableHead", LazyUITableHead],
["UITable", LazyUITable],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
